import React, { useEffect, useState } from 'react'

//Estilo Primario
import '../../../assets/dist/stilo.css'
import parse from 'html-react-parser';

//Logos
import logoAcreUDD from '../../../assets/images/background.jpg';
import Footer from '../../util/Footer';
import NewHeaderInicio from '../../util/NewHeaderInicio';
import { CircularProgress } from '@material-ui/core';
import { useStyles } from '../../view-model/Inicio/InicioEstudiante.logic';

import IViewDatosPersonales from '../../view-interfaces/IViewDatosPersonales';
import { format } from 'fecha';
import { Alert } from '@material-ui/lab';
import { FormControl, Grid, Paper } from '@material-ui/core';
import { ObtieneParametrosLogic, ObtieneMensajeBloqueoAccesoLogic } from '../../view-model/Parametros/Parametros.logic';
import IViewParametros from '../../view-interfaces/IViewParametros';
import { useHistory } from 'react-router-dom';
import { GetBrowserInfo } from '../../view-model/Funciones/BrowserInfo';

/* import ScriptTag from 'react-script-tag'; */
// import { con } from '../../../application/entity/Rutas';
const { validarRUT } = require('validar-rut')
const { formatterRut, cleanRut } = require('chilean-formatter')

const InicioEstudiante: React.FC = () => {
    const history = useHistory();
    const [rut, setRut] = useState('');
    const [estiloRut, setEstiloRut] = useState('form-control js-rut js-will-validate');
    const [disableBotonIngresar, setDisableBotonIngresar] = useState(true);
    const lista: Array<IViewDatosPersonales> = [];
    const [persona, setPersona] = useState(lista);
    const [error, setError] = useState(false);
    const [mensajeError, setmensajeError] = useState('')
    const [codigoParametro, setCodigoParametro] = useState('AMW');
    const listaP: Array<IViewParametros> = [];
    const [listParams, setlistParams] = useState(listaP);
    const [cargando, setCargando] = useState(false)

    const [rutIncorrecto, setRutIncorrecto] = useState(false)

    const [varMensajeBloqueo, setVarMensajeBloqueo] = useState(false)
    const [varTextoMensajeBloqueo, setVarTextoMensajeBloqueo] = useState('')

    // var getBrowserInfo = function() {
    //     var ua= navigator.userAgent, tem, 
    //     M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    //     if(/trident/i.test(M[1])){
    //         tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
    //         return 'IE '+(tem[1] || '');
    //     }
    //     if(M[1]=== 'Chrome'){
    //         tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
    //         if(tem!== null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    //     }
    //     M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    //     if((tem= ua.match(/version\/(\d+)/i))!== null) M.splice(1, 1, tem[1]);
    //     return M.join(' ');
    // };

    //console.log(GetBrowserInfo());

    const selListaParametros = (error: Boolean, err: string, Parametros: IViewParametros[]) => {
        try {
            if (error === false && Parametros.length > 0) {
                setlistParams(Parametros);
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    const handleBuscarPostulante = (_rut: string) => {
        setCargando(true)
        history.push({
            pathname: "/preguntas",
            state: {
                rut: _rut.replaceAll('.', '')
            }
        });
    }

    const handleParametrosSistema = () => {
        ObtieneParametrosLogic(selListaParametros, codigoParametro);
        ObtieneMensajeBloqueoAccesoLogic(selMensajeBloqueoAcceso);
    }

    const selMensajeBloqueoAcceso = (error: Boolean, err: string, result: any) => {
        try {
            if (error === false && result.idMensajeBloqueoAcceso > 0) {
                setVarMensajeBloqueo(true);
                setVarTextoMensajeBloqueo(result.mensajeBloqueo);
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    const handleValidaRut = () => {
        try {
            if (rut.trim().length <= 20) {
                if (validarRUT(rut.trim())) {
                    let _rut = rut;
                    setRut(formatterRut(rut.trim()));
                    setRutIncorrecto(false)
                    setEstiloRut("form-control js-rut js-will-validate is-valid");
                    //setDisableBotonIngresar(false);
                    if (error === true) {
                        setError(false);
                        setRutIncorrecto(false)
                        setmensajeError('');
                    }
                    handleBuscarPostulante(_rut);
                }
                else {
                    setEstiloRut("form-control js-rut js-will-validate is-invalid")
                    setDisableBotonIngresar(true)
                    setRutIncorrecto(true)
                    setError(false);
                    setmensajeError('')
                }
            } else {

            }

            if (rut.trim().length > 13) {
                setRut('');
                setRutIncorrecto(true)
                setEstiloRut('form-control js-rut js-will-validate');
                setDisableBotonIngresar(true);
            }

            if (rut.trim().length < 5) {
                setError(false);
                setRutIncorrecto(true)
                setmensajeError('');
                setEstiloRut('form-control js-rut js-will-validate');
            }

        } catch (error) {
            setError(true);
            setRutIncorrecto(true)
            setmensajeError('Ha ocurrido un error al validar el rut')
        }

    }

    //Se debe ejecutar solo
    useEffect(() => {
        handleParametrosSistema();
    }, [])

    useEffect(() => {
        setError(false);
        setRutIncorrecto(false)
        setmensajeError('');
    }, [rut]);

    const classes = useStyles();

    return (
        <>
            <NewHeaderInicio />
            <main className="welcome site-main">
                <div className="welcome__media">
                    <img src={logoAcreUDD} alt="Logo Acreditación UDD" className="hero__media-image" width="1920" height="1920" />
                </div>
                <div className="site-main__container">
                    <div className="site-main__title">Bienvenido al Sistema de Matrícula Web UDD</div>
                    {
                        varMensajeBloqueo ?
                            <Grid container spacing={0} item xs={12}>
                                <Paper className={classes.alertMail} elevation={0}>
                                    <Grid item xs>
                                        <Alert variant="outlined" severity="error" style={{ border: '2px solid #7c1b13', fontSize: 12 }}>
                                            <p>
                                                <p>{parse(varTextoMensajeBloqueo)}</p>
                                            </p>
                                        </Alert>
                                    </Grid>
                                </Paper>
                            </Grid>
                            :
                            <>
                                <p className="site-main__description">Para acceder al portal, ingresar el rut (alumno/postulante):</p>
                                <div>
                                    <div className="form-group site-main__login">
                                        <input
                                            className={estiloRut}
                                            type="text"
                                            value={rut}
                                            maxLength={13}
                                            placeholder={'99.999.999-9'}
                                            onChange={(e) =>
                                                setRut(formatterRut(e.target.value.trim()))
                                            } />

                                        {
                                            <button id="btn-submit"
                                                className="btn btn-primary site-main__btn g-recaptcha"
                                                onClick={handleValidaRut}
                                                type="submit">
                                                {cargando ? (error || rutIncorrecto ? "Ingresar" : <CircularProgress color="inherit" size={20} disableShrink />) : "Ingresar"}
                                            </button>
                                        }

                                    </div>
                                </div>
                                <p style={{ color: '#fff', fontSize: '10' }}>Se recomienda utilizar los siguientes navegadores:<br />
                                    * Google Chrome<br />
                                    * Mozilla Firefox<br />
                                    * Opera<br />
                                    * Microsoft Edge
                                </p>
                            </>
                    }
                    {
                        rut.trim().length > 0 ?
                            rutIncorrecto ?
                                <Grid container spacing={0} item xs={6}>
                                    <Paper className={classes.alertMail} elevation={0}>
                                        <Grid item xs>
                                            <FormControl style={{ width: '90%' }} className={classes.formControlAlertMail} variant='outlined' component='fieldset'>
                                                <Alert variant="outlined" severity="error">
                                                    <div style={{ fontSize: 13 }}>
                                                        RUT incorrecto
                                                    </div>
                                                </Alert>
                                            </FormControl>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                :
                                "" :
                            ""
                    }
                    {
                        error ?
                            <Grid container spacing={0} item xs={12}>
                                <Paper className={classes.alertMail} elevation={0}>
                                    <Grid item xs>
                                        <FormControl className={classes.formControlAlertMail} variant='outlined' component='fieldset'>
                                            <Alert variant="outlined" severity="error">
                                                <div style={{ fontSize: 13 }}>
                                                    {mensajeError}
                                                    <br></br>
                                                    Por favor comunicarse a través del formulario de atención: <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/"><u>https://contacto.udd.cl/</u></a>.
                                                </div>
                                            </Alert>
                                        </FormControl>
                                    </Grid>
                                </Paper>
                            </Grid>
                            :
                            ''
                    }
                </div>
            </main>
            <Footer />
        </>
    );
}

export default InicioEstudiante;